<template>
	<layout>
		<div class="container">
			<h2 class="title is-5">Запрос сведений, документов, материалов, содержащихся в ГИСОГД</h2>
			<p class="subtitle is-6">Эта страница находится в разработке.</p>
			<img src="../assets/svg/page_in_development.svg" width="656" height="192" />
		</div>
	</layout>
</template>

<script>
	import Layout from './Layout'
	export default {
		components: {
			Layout
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container {
		text-align: center;
		padding-top: 40px;
	}

	.subtitle {
		padding: 45px 0px 15px 0px;
	}
</style>